import { ApplicationConfig, APP_INITIALIZER, inject, provideZoneChangeDetection, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
// import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { errorInterceptor } from '../interceptors/error.interceptor';

// import { TranslateModule, TranslateService } from '@ngx-translate/core';
// import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

// import {provideTranslateService} from "@ngx-translate/core";


import { provideTranslateService, provideTranslateLoader } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideHttpClient, withInterceptors } from "@angular/common/http";

// No custom factory needed; use provideTranslateHttpLoader below.

export const appConfig: ApplicationConfig = {
  providers: [
    // TranslateModule.forRoot().ngModule,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptors([errorInterceptor])),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en',
      lang: 'en'
    })
    // provideTranslateService({
    //   fallbackLang: 'en',
    //   lang: 'en'
    // })
    // provideTranslateHttpLoader({ prefix: '/assets/i18n/', suffix: '.json' }),
    // TranslateModule.forRoot().providers!,
    // {
    //   provide: APP_INITIALIZER,
    //   multi: true,
    //   useFactory: () => {
    //     const translate = inject(TranslateService);
    //     const router = inject(Router);
    //     return () => {
    //       const supported = ['en','ja','ko','ms','vi','zh'];
    //       translate.addLangs(supported);
    //       const seg = router.url.split('?')[0].split('/')[1];
    //       const lang = supported.includes(seg) ? seg : 'en';
    //       translate.use(lang).subscribe();
    //     };
    //   }
    // }
    // Use relative prefix so it works under nested language segment & SSR
    // Use absolute path so requests aren't nested under /:lang/...
    // provideTranslateHttpLoader({ prefix: '/assets/i18n/', suffix: '.json' }),
    // Root TranslateModule providers
    // TranslateModule.forRoot().providers!,
    //   {
    //     provide: APP_INITIALIZER,
    //     multi: true,
    //     useFactory: () => {
    //       const translate = inject(TranslateService);
    //       const router = inject(Router);
    //       const platformId = inject(PLATFORM_ID);
    //       return () => new Promise<void>((resolve) => {
    //         const supported = ['en','ja','ko','ms','vi','zh'];
    //         translate.addLangs(supported);
    //         translate.setFallbackLang('en').subscribe();
    //         let initial: string | undefined;
    //         if (typeof window !== 'undefined' && (platformId as any) !== 'server') {
    //           const parts = window.location.pathname.split('/');
    //           if (parts.length > 1) {
    //             const candidate = parts[1];
    //             if (supported.includes(candidate)) initial = candidate;
    //           }
    //         }
    //         // Fallback if not derived yet
    //         if (!initial) {
    //           const direct = router.url.split('?')[0].split('/')[1];
    //           if (supported.includes(direct)) initial = direct; else initial = 'en';
    //         }
    //         translate.use(initial).subscribe({
    //           next: () => {
    //             console.log('[i18n] init lang', initial);
    //             resolve();
    //           },
    //           error: (e) => { console.error('[i18n] init failed', initial, e); resolve(); }
    //         });
    //         let started = false;
    //         router.events.subscribe(ev => {
    //           if (ev instanceof NavigationEnd) {
    //             if (!started) { started = true; }
    //             const lang = ev.urlAfterRedirects.split('?')[0].split('/')[1];
    //             if (supported.includes(lang) && lang !== translate.getCurrentLang()) {
    //               translate.use(lang).subscribe();
    //             }
    //           }
    //         });
    //       });
    //     }
    //   }
  ],
};
